// @flow
/* eslint-disable react/no-danger */
import React from 'react';
import { Link } from 'react-router-dom';
import ContentModule from '../ContentModule';
import Accordion from '../Accordion';
import LandingPageIcon from '../../LandingPage/LandingPageIcon';

import { groupsOf } from '../../../helpers/utils';
import '../../../../static/scss/components/subsectionsPanel.scss';

const groupsOfThree = groupsOf(3);

type Amenities = {
  category: string,
  distance: number,
  name: string,
  subCategory: string,
  uri: string
};

type Subsections = {
  body: string,
  title: string,
  type: string
};

type Props = {
  activeTab: string,
  subsections: Array<Subsections>,
  amenities: Array<Amenities>,
  subtext: string,
  modifier: string
};

const renderAmenity = (amenity) => (
  <li
    className={`c-amenity c-amenity--${amenity.category.toLowerCase()} c-amenity--${amenity.subCategory?.toLowerCase()}`}
  >
    <span />
    <Link to={`/${amenity.uri}`}>{amenity.name}</Link>
  </li>
);

const renderAmenities = (amenities) => (
  <div className="c-amenities">
    <div>
      {groupsOfThree(amenities).map((group) => (
        <ul>{group.map(renderAmenity)}</ul>
      ))}
    </div>
  </div>
);

const renderSubsection = (elem, amenities = false) => (
  <div className={elem.type}>
    <header>
      <span>
        <LandingPageIcon
          iconName={elem.type}
          className="c-accordion-item__icon"
        />
      </span>
      <h3 className={elem.type}>{elem.title}</h3>
    </header>
    <div>
      {elem.body && <div dangerouslySetInnerHTML={{ __html: elem.body }} />}
      {amenities && renderAmenities(amenities)}
    </div>
  </div>
);

const renderSubsections = (subsections, amenities) =>
  subsections.map((subsection) =>
    subsection.type === 'nearby_attractions'
      ? renderSubsection(subsection, amenities)
      : renderSubsection(subsection)
  );

const parseSubtext = (subtext) => subtext.replace(/-/g, ' ');

const SubsectionsPanel = ({
  activeTab,
  subsections,
  amenities,
  subtext,
  modifier
}: Props) => (
  <ContentModule baseClassName="subsections" modifier={modifier}>
    <div className="c-subsections__headings">
      <h2>
        Additional <span>Information</span>
      </h2>
      <p className="c-subsections__subheading">
        Some additional information about parking in{' '}
        <span className="c-subsections__subheading__subtext">
          {parseSubtext(subtext)}
        </span>
        , to cater to all your parking needs
      </p>
    </div>
    <Accordion activeTab={activeTab}>
      {renderSubsections(subsections, amenities)}
    </Accordion>
  </ContentModule>
);

export default SubsectionsPanel;
